module.exports = __webpack_public_path__ + "static/media/2empty.891c6e6e.png";